import { IReward } from './IReward';
import { Reward } from './Reward';
import MinBalanceCalculationMethods from '../MinBalanceCalculationMethods';
import BalanceTypes from '../BalanceTypes';

export class MinimumBalanceFeeReductionReward extends Reward {
	public static readonly CLASS: string = 'com.bancvue.rcx.config.product.rewards.api.MinimumBalanceFeeReductionReward';

	public static readonly NAME: string = 'Minimum Balance Fee Reduction';

	minimumBalanceAmount: number = 0;

	balanceType: string = BalanceTypes.AVAILABLE.value;

	calculationMethod: string = MinBalanceCalculationMethods.AVERAGE_DAILY_BALANCE.value;

	minimumBalanceFeeReductionAmount: number = 0;

	constructor(reward?: IReward) {
	  super(MinimumBalanceFeeReductionReward.CLASS, reward ? reward.id : null);

	  if (reward) {
	    this.minimumBalanceAmount = (reward as any).minimumBalanceAmount;
	    this.balanceType = (reward as any).balanceType;
	    this.calculationMethod = (reward as any).calculationMethod;
	    this.minimumBalanceFeeReductionAmount = (reward as any).minimumBalanceFeeReductionAmount;
	  }
	}

	getDescription(): string {
	  return `$${this.minimumBalanceFeeReductionAmount} fee reduction on Minimum Balance: ${this.minimumBalanceAmount
	  }, Type: ${BalanceTypes[this.balanceType]}, Method: ${MinBalanceCalculationMethods[this.calculationMethod]}`;
	}

	clone(): IReward {
	  const clone = new MinimumBalanceFeeReductionReward();
	  Object.assign(clone, this);
	  return clone;
	}
}

export default MinimumBalanceFeeReductionReward;
